"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ensureAjsAnonymousIdCookie;

var _uuid = _interopRequireDefault(require("uuid"));

var _cookieUtils = _interopRequireDefault(require("../utils/cookieUtils"));

var _constants = require("../constants");

var ajsAnonymousIdKey = 'ajs_anonymous_id';

function ensureAjsAnonymousIdCookie() {
  if (_constants.isServer) {
    throw new Error('ensureAjsAnonymousIdCookie should only be called from a browser client but was called on the server');
  }

  if (_cookieUtils.default.getCookie(ajsAnonymousIdKey)) {
    return;
  }

  var domain = function () {
    var href = window.location.href;

    if (href.includes('.angieslist')) {
      return '.angieslist.com';
    } else if (href.includes('.angi')) {
      return '.angi.com';
    } else {
      return undefined;
    }
  }();

  var expireDate = new Date();
  expireDate.setFullYear(expireDate.getFullYear() + 1); // Set 1 year cookie using format expected by Segment (encodeURIComponent(`"${uuid.v4()}"`)

  _cookieUtils.default.setCookieV2({
    domain: domain,
    key: ajsAnonymousIdKey,
    value: "".concat(_uuid.default.v4()),
    expires: expireDate.toUTCString()
  });
}

module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-app-platform/lib/common/analytics/ensureAjsAnonymousIdCookie.js
// module id = 2069
// module chunks = 25